import { Flex, Pagination } from '@applyboard/crystal-ui';
import { queryParameterContext, useStaticProps, useSearchResult } from '../context';

export function CourseMappingsPagination() {
  const { referenceData } = useStaticProps();
  const { totalCourseMappings } = useSearchResult();
  const pageNumberFilter = queryParameterContext.useFilterField('pageNumber', 'Pagination');
  const pageSizeFilter = queryParameterContext.useFilterField('pageSize', 'Pagination');

  return (
    <Flex align="center" pt={10} grow={1}>
      <Flex.Item grow={1}>
        <Pagination
          numItems={totalCourseMappings}
          currentPage={pageNumberFilter.value}
          pageSize={pageSizeFilter.value}
          onPageSizeChange={(pageSize) => pageSizeFilter.setValue(pageSize)}
          disabled={totalCourseMappings <= 0}
          onPageChange={(pageNumber) => pageNumberFilter.setValue(pageNumber)}
          variant="items"
          pageSizeOptions={referenceData.pageSizes}
        />
      </Flex.Item>
    </Flex>
  );
}
